import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';

const regions = [
    // Ghana Regions
    { name: 'Ghana - Ashanti', image: '/assets/ashantiregion.jpg' },
    { name: 'Ghana - Greater Accra', image: '/assets/Acca.jpg' },
    { name: 'Ghana - Central', image: '/assets/central.jpg' },
    // South Africa Regions
    { name: 'South Africa - Western Cape', image: '/assets/Western-Cape.webp' },
    { name: 'South Africa - Gauteng', image: '/assets/guateng.webp' },
    // Ethiopia Regions
    { name: 'Ethiopia - Addis Ababa', image: '/assets/addisababa.png' },
    { name: 'Ethiopia - Amhara', image: '/assets/amhara.jpg' },
    { name: 'Ethiopia - Oromia', image: '/assets/oromia.jpg' },
];

const experiences = [
    {
        title: 'Cultural Festivals',
        description: 'Immerse yourself in the vibrant traditions and celebrations of Africa.',
        image: '/assets/cultural1.webp',
    },
    {
        title: 'Historical Tours',
        description: 'Explore the castles and forts that tell the story of Africa\'s past.',
        image: '/assets/historical1.jpg',
    },
    {
        title: 'Wildlife Safaris',
        description: 'Discover the rich biodiversity of Africa in its national parks.',
        image: '/assets/safari.webp',
    },
];

const GhanaRegions = () => {
    const navigate = useNavigate();

    const handleExplore = (experienceTitle) => {
        if (experienceTitle === 'Cultural Festivals') {
            navigate('/cultural-festivals');
        } else if (experienceTitle === 'Historical Tours') {
            navigate('/historical-tours');
        } else if (experienceTitle === 'Wildlife Safaris') {
            navigate('/wildlife-safaris');
        }
    };
    return (
        <section className="bg-white py-20 px-4">
            <div className="container mx-auto text-center">
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                    <h2 className="text-4xl md:text-4xl font-semibold text-gray-800 font-cormorant-upright mb-4">Discover African Regions</h2>
                    <p className="text-gray-600 mb-16 max-w-2xl mx-auto">Explore the rich diversity of Africa with unique adventures in each sub-saharan region.</p>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={400}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                        {regions.map((region, index) => (
                            <a href="/virtual-tour" key={index} className="relative block h-64 rounded-lg overflow-hidden shadow-lg group transform hover:-translate-y-2 transition-transform duration-300">
                                <img
                                    src={region.image}
                                    alt={`View of ${region.name} Region`}
                                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/10"></div>
                                <div className="absolute bottom-0 left-0 p-4">
                                    <h3 className="text-white text-lg font-bold">{region.name}</h3>
                                </div>
                            </a>
                        ))}
                    </div>
                </ScrollReveal>
                {/* experience ghana */}
                <div className="mt-24">
                    <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                        <h2 className="text-4xl md:text-4xl font-semibold text-gray-800 font-cormorant-upright mb-4">Experience Africa</h2>
                        <p className="text-gray-600 mb-16 max-w-2xl mx-auto">Dive into the heart of Ghana with these unique experiences.</p>
                    </ScrollReveal>
                    <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={400}>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {experiences.map((exp, index) => (
                                <div key={index} className="relative rounded-lg overflow-hidden shadow-lg group">
                                    <img src={exp.image} alt={exp.title} className="w-full h-80 object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 p-6 text-left">
                                        <h3 className="text-white text-2xl font-bold font-cormorant-upright">{exp.title}</h3>
                                        <p className="text-gray-200 mt-2">{exp.description}</p>
                                        <button onClick={() => handleExplore(exp.title)} className="inline-block mt-4 px-6 py-2 text-sm bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors duration-300">
                                            Explore
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
};

export default GhanaRegions;